module.exports = __webpack_public_path__ + "static/media/searchi.71fdecdc.png";